<template>
  <div class="login_container">
    <div>
      <div class="login_form">
        <div class="form-title">
          <div>软件自动更新管理系统</div>
        </div>
        <div class="login_box">
          <el-form
            :model="dataForm"
            :rules="dataRule"
            ref="dataForm"
            @keyup.enter.native="dataFormSubmit()"
            status-icon
          >
            <el-form-item prop="username">
              <el-input v-model="dataForm.username" placeholder="账号"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="dataForm.password" type="password" placeholder="密码"></el-input>
            </el-form-item>
            <el-form-item>
              <div class="login-btn-submit" @click="dataFormSubmit()">登录</div>
              <!-- <el-button class="login-btn-submit" type="primary" @click="dataFormSubmit()">登录</el-button> -->
            </el-form-item>
          </el-form>
        </div>
        <div class="logo_img">
          <!-- <img src="../assets/img/logo.png" /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataForm: {
        username: '',
        password: ''
      },
      dataRule: {
        username: [{ required: true, message: '帐号不能为空', trigger: 'blur' }],
        password: [{ required: true, message: '密码不能为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    dataFormSubmit() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl('/api/v1/auth/login'),
            xhrFields: {
              withCredentials: true
            },
            method: 'POST',

            data: this.$http.adornData(this.dataForm)
          })
            .then(res => {
              if (res.resp_code === 0) {
                this.$cookie.set('token', res.data.token)

                this.getUserName()
              } else {
                this.$message.error(res.resp_msg)
              }
            })
            .catch(() => {})
        }
      })
    },
    getUserName() {
      this.$http({
        url: this.$http.adornUrl('/api/app/getUsername'),
        method: 'GET'
      }).then(res => {
        if (res.resp_code === 0) {
          this.userName = res.data.username
          if (res.data.perm !== 'admin') {
            this.$router.push('/production')
          } else {
            this.$router.push('/manage/user')
          }
        } else {
          this.userName = 'admin'
          this.$message.error(res.resp_msg)
          this.$router.push('/manage/user')
        }
        this.$store.commit('updateUserName', this.userName)
        this.$store.commit('updatePerm', res.data.perm)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login_container {
  background: url('../assets/img/login.jpg');
  width: 100%;
  height: 100%;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
}
.logo_img {
  margin-top: 161px;
  img {
    width: 117px;
    height: 100%;
  }
}
.login_form {
  height: 100%;
  width: 538px;
  position: absolute;
  right: 240px;
  text-align: center;
}
.login_box {
  box-sizing: border-box;
  margin-top: 32px;
  padding: 60px;
  border-radius: 20px;
  background: #fff;
  .login-btn-submit {
    width: 100%;
    text-align: center;
    background: #409eff;
    color: #fff;
    border-radius: 20px;
    cursor: pointer;
    margin-top: 20px;
  }
  .login-btn-submit:active {
    background: #3b90e7;
  }
  .login-captcha {
    overflow: hidden;
    > img {
      width: 100%;
      cursor: pointer;
    }
  }
  .dwnld {
    display: flex;
    display: -webkit-flex;
    justify-content: space-around;
    .dwnld-btn {
      height: 60px;
      width: 60px;
      text-align: center;
    }
    .img-btn {
      height: 50px;
      cursor: pointer;
    }
    .img-btn:hover {
      height: 60px;
    }
  }
}
.form-title {
  height: 48px;
  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #dee4f7;
  line-height: 48px;
  margin-top: 224px;
  div:nth-of-type(1) {
    font-size: 34px;
    text-align: center;
  }
  div:nth-of-type(2) {
    font-size: 36px;
  }
}
</style>
